export default "__VITE_ASSET__d96f65dd__$_?nuxt_component=async__"